<template>
  <div id="app">
    <TopBar v-if="showTopBar" />
    <CategoryBar v-if="showCategoryBar" />
    <router-view />
    <BottomNavBar v-if="showBottomNav" />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'

import TopBar from './components/TopBar.vue'
import BottomNavBar from './components/BottomNavBar.vue'
import CategoryBar from '@/components/CategoryBar.vue'

import { useAuthStore } from './stores/auth'
import api from './services/api'

const route = useRoute()
const authStore = useAuthStore()

// Cargar usuario
onMounted(async () => {
  const token = localStorage.getItem('auth_token')
  if (token && !authStore.user) {
    try {
      const res = await api.get('/app/user')
      authStore.user = res.data.user
    } catch (e) {
      console.error('Error cargando usuario', e)
      localStorage.removeItem('auth_token')
    }
  }
})

// Rutas que NO deben mostrar las barras
const authRoutes = ['Splash', 'Login', 'Register', 'ForgotPassword', 'ResetPassword']

// 🔥 TOP BAR - Mostrar en estas rutas (excluyendo auth)
const showTopBar = computed(() => {
  const showRoutes = ['Home', 'Express', 'Tendencia', 'Radio', 'Mizona', 'categoria']
  const shouldShow = showRoutes.includes(route.name) && !authRoutes.includes(route.name)
  return shouldShow
})

// 🔥 CATEGORY BAR
const showCategoryBar = computed(() => {
  const showRoutes = ['Home', 'categoria', 'Tendencia']
  return showRoutes.includes(route.name) && !authRoutes.includes(route.name)
})

// 🔥 BOTTOM NAV
const showBottomNav = computed(() => {
  const showRoutes = [
    'Home', 'Express', 'Tendencia', 'Radio', 'Mizona', 'NoticiaDetail',
    'EditPerfil', 'Misuscripcion', 'favoritos', 'newsletters',
    'avisolegal', 'policy', 'anunciaconnosotros', 'quienes-somos',
    'equipo-editorial', 'categoria'
  ]
  return showRoutes.includes(route.name) && !authRoutes.includes(route.name)
})
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  background: #fff;
}

#app {
  min-height: 100vh;
  padding-bottom: 70px; /* Espacio para el BottomNav */
}
</style>